import { Stack, SxProps, Typography } from '@mui/material'
import { t } from '$i18n'
import { GroupIcon } from '$common/icons'

interface Props {
  Icon?: ({ ...props }) => JSX.Element
  text?: string
  sx?: SxProps
}

export function EmptyStateList({
  // eslint-disable-next-line react/jsx-props-no-spreading
  Icon = ({ ...props }) => <GroupIcon {...props} />,
  text = t('emptyState.noUserFound'),
  sx,
}: Props) {
  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      sx={{
        height: '100%',
        ...sx,
      }}
    >
      <Icon sx={{ width: '68px', height: '52px', color: 'lightGray' }} />
      <Typography variant="body2" color="gray">
        {text}
      </Typography>
    </Stack>
  )
}
